import recaptchaUrls from './recaptcha.urls';
import { RecaptchaDto } from './recaptcha.dto';
import { networkService, getData, rejectPromise } from '@project/services';

const verifyRecaptcha = (data?: string | null) => {
  const url = recaptchaUrls.getVerficationUrl();
  const dto = RecaptchaDto(data);

  return networkService.post(url, dto).then(getData).catch(rejectPromise);
};

export default { verifyRecaptcha };
